var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCommand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8v8H8V8h8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 22c1.65 0 3-1.35 3-3v-3H5c-1.65 0-3 1.35-3 3s1.35 3 3 3zM2 5c0 1.65 1.35 3 3 3h3V5c0-1.65-1.35-3-3-3S2 3.35 2 5zM19 2c-1.65 0-3 1.35-3 3v3h3c1.65 0 3-1.35 3-3s-1.35-3-3-3zM16 16v3c0 1.65 1.35 3 3 3s3-1.35 3-3-1.35-3-3-3h-3z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCommand);
export default __webpack_public_path__ + "static/media/vuesax-bold-command.7a26faf994eb824247b54f7c98aa19d3.svg";
export { ForwardRef as ReactComponent };